import React from "react";
import AchievementCard1Section4 from "./AchievementCard1Section4";

const AchievementCardSection4 = (props) => {
  if (props.row === "top") {
    return (
      <div className="two lg:flex">
        <AchievementCard1Section4
          image="https://cdn-icons-png.flaticon.com/512/8649/8649940.png"
          heading="Academic Prize"
          para="The Academic Excellence Award is conferred on a student whose academic performance during the year demonstrates remarkable consistency at the highest level of achievement."
        />
        <AchievementCard1Section4
          image="https://cdn-icons-png.flaticon.com/512/8649/8649940.png"
          heading="Class Representative"
          para=" Act as a prime official channel of communication between teacher and rest of the class, for all monitoring formalities"
        />
        <AchievementCard1Section4
          image="https://cdn-icons-png.flaticon.com/512/8649/8649940.png"
          heading="Competitions"
          para="A prize competition is gambling which has an element of chance but also requires participants to exercise some knowledge or skill."
        />
      </div>
    );
  } else {
    return (
      <div className="two lg:flex">
        <AchievementCard1Section4
          image="https://cdn-icons-png.flaticon.com/512/8649/8649940.png"
          heading="Extracurricular Activity "
          para="Extracurriculars are anything you do outside of academics. These can include sports, music, community service activities, jobs/internships, clubs, and more"
        />
        <AchievementCard1Section4
          image="https://cdn-icons-png.flaticon.com/512/8649/8649940.png"
          heading="Attendance Award"
          para="a way to honor students who were present for every day of school during that year, or in some cases across multiple years."
        />
        <AchievementCard1Section4
          image="https://cdn-icons-png.flaticon.com/512/8649/8649940.png"
          heading="Volunteering"
          para="A volunteer is someone who does work without being paid for it, because they want to do it."
        />
      </div>
    );
  }
};
export default AchievementCardSection4;
